import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77290c2e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77290c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/NewRabbit/newRabbitAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77290c2e')) {
      api.createRecord('77290c2e', component.options)
    } else {
      api.reload('77290c2e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77290c2e&scoped=true&", function () {
      api.rerender('77290c2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/systemCreator/systemConfig/areaConfig/index.vue"
export default component.exports